<template>
<div id="turn-area-card">

  <div id="player-card" v-if="!activePlayer.isAi" v-on:mouseover="select"
      draggable v-on:dragstart="startDrag($event)" :ondragstart="ondragstart">

    <img :src="card.image" class="card">

    <div v-if="isShowing" id="overlays" class="play">
      <input type="image" id="discard-button"
         title="Discard Card"
         src="static/miscIcons/trash.png"
         v-on:click="discard">

      <effect-card-popup></effect-card-popup>

    </div>
  </div> 

  <div v-else ondragstart="return false;">
    <img src="static/cardImages/backOfCard.png" class="card">
  </div>
</div>
</template>


<script>
import EffectCardPopup from '@/components/game/EffectCardPopup'
import {mapMutations, mapState, mapActions} from 'vuex'

/**
 * Display for a card in the turn area.
 * Shows a card image as well as necessary overlays like discard button and
 * popups for targeting with special cards.
 * Is also responsible for setting the active card and starting the dragging
 * for a card that is being played.
 */
export default {
  name: 'turn-area-card',
  props: ['card'],
  data () {
    return {
      type: this.card.type,
      targetText: "Targets"
    }
  },
  components: {
    'effect-card-popup': EffectCardPopup
  },
  computed: {
    ...mapState([
      'activeCard',
      'activePlayer'
    ]),
    isShowing () {
      return this.activeCard === this.card && !this.activePlayer.isAi
    },
    ondragstart () {
      // The ondragstart attribute requires a string "return bool;" so here
      // we are building one to make sure special cards can't be dragged.
      return "return " + !this.card.isSpecial()
    }
  },
  methods: {
    ...mapMutations([
      'setActiveCard',
    ]),
    ...mapActions([
      'executeTurn'
    ]),
    /**
     * Selects this.card as the active card.
     */
    select () {
      this.setActiveCard({newCard: this.card})
    },
    /**
     * Discard the activeCard and end the activePlayers turn.
     */
    discard () {
      this.executeTurn({
        playType: "DISCARD",
        card: this.activeCard,
        player: this.activePlayer,
        target: this.activePlayer
      })
    },
    /**
     * Setup drag event with necessary data when a card starts being dragged.
     */
    startDrag (evt) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('cardId', this.card.id)
    }
  },
}
</script>


<style scoped>
#turn-area-card {
  position: relative;
  width: 100%;
  height: 100%;
}

#overlays {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

#discard-button {
  position: absolute;
  left: -8px;
  top: -8px;
  width: 25px;
  height: 25px; 
}

.card {
  max-width: 90px;
  max-height: 134px;
}

.play {
  -webkit-box-shadow: 0 0 24px 8px rgba(0,230,0,1);
  -moz-box-shadow: 0 0 24px 8px rgba(0,230,0,1);
  box-shadow: 0 0 24px 8px rgba(0,230,0,1);
}
</style>

